<script setup>
import { Card } from "@/components/ui/card";
import { CalendarDays } from "lucide-vue-next";
import CardFooter from "./ui/card/CardFooter.vue";

const props = defineProps({
  title: String,
  date: String,
  imageUrl: String,
  signedUp: Boolean,
});
</script>

<template>
  <Card
    class="w-full h-32 overflow-hidden relative border-none cursor-pointer"
    :style="{
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)), url('${imageUrl}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }"
  >
    <div
      v-if="signedUp"
      class="absolute top-0 right-0 w-0 h-0 border-l-60 border-l-transparent border-t-60 border-t-primary z-30 "
    ></div>
    <div
      v-if="signedUp"
      class="absolute transform rotate-45 font-light text-[10px] px-2 py-1 z-31"
      style="top: 11px; right: -9px"
    >
      Signed Up
    </div>
    <CardFooter>
      <div class="w-full h-full">
        <div class="flex flex-col">
          <div class="grow items-center justify-center size-10"></div>
          <div class="flex-none">
            <h3
              class="font-semibold text-primary-foreground truncate dark:text-primary-foreground"
            >
              {{ title }}
            </h3>
            <p class="text-sm text-primary-foreground">
              <span class="flex items-center gap-2">
                <CalendarDays class="w-4 h-4"></CalendarDays>
                <span class="text-xs truncate">{{ date }}</span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </CardFooter>
  </Card>
</template>
